import { openExternal } from './openExternal';

const sanitizeFileName = (name = 'documento.pdf') => {
  const cleaned = String(name)
    .replace(/[<>:"/\\|?*\u0000-\u001F]/g, '_')
    .trim();

  if (!cleaned) {
    return 'documento.pdf';
  }

  return cleaned.toLowerCase().endsWith('.pdf') ? cleaned : `${cleaned}.pdf`;
};

export async function downloadNativePdf({ url, fileName }) {
  const wantsNativeDownload = window.confirm(
    'Quieres descargar este PDF en tu dispositivo? Si cancelas o falla, lo abriremos en el navegador.'
  );

  if (!wantsNativeDownload) {
    await openExternal(url);
    return { mode: 'browser' };
  }

  try {
    const [{ Filesystem, Directory }, { Share }] = await Promise.all([
      import('@capacitor/filesystem'),
      import('@capacitor/share'),
    ]);

    const safeFileName = sanitizeFileName(fileName);
    const relativePath = `descargas/${Date.now()}-${safeFileName}`;

    await Filesystem.downloadFile({
      url,
      path: relativePath,
      directory: Directory.Documents,
      recursive: true,
    });

    const { uri } = await Filesystem.getUri({
      directory: Directory.Documents,
      path: relativePath,
    });

    await Share.share({
      title: safeFileName,
      text: 'Guardar PDF',
      url: uri,
      dialogTitle: 'Guardar PDF',
    });

    return { mode: 'native', uri };
  } catch (error) {
    console.error('Descarga nativa de PDF fallida:', error);
    await openExternal(url);
    return { mode: 'browser-fallback', error };
  }
}
